import { feathers } from '@/feathers-client';

export default {
  namespaced: true,
  state: {
    data: [],
    hasError: false,
    errorMsg: '',
    hasSuccess: false,
    isLoading: false,
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setError(state, error) {
      state.hasError = true;
      state.errorMsg = error.error;
    },
    clearError(state) {
      state.hasError = false;
      state.errorMsg = '';
    },
    setSuccess(state, bool) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = bool;
    },
    clearMessages(state) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = false;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
  },
  actions: {
    async findLeadSourceProviders({ commit }, query = {}) {
      commit('setIsLoading', true);
      try {
        const response = await feathers.service('lead-sources').find({ query });
        commit('setData', response.data);
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
};
